import { bool, func, shape, string } from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { fetchCardDataYsc, fetchYscTransactionLimit, generateOtp, updateYscTransactionLimits } from './actions';
import { select_card_data_ysc } from '../NetworkCards/selectors';
import { fetchYscTransaction, generateOtpIndusind, isTransactionLimitsLoading, updateYscTransaction } from './selectors';
import { selectHeaderContainerJS, selectUserDetails } from '../HeaderContainer/selectors';
import { FETCH_YSC_TRANSACTION_LIMIT, GENERATE_OTP } from './constants';
import { isLoading } from '../PayBalance/selectors';

const YscTransactionLimitsPropTypes = {
  isTransactionLimitsLoading: bool.isRequired,
  isLoadingStatus: bool.isRequired,
  CardDataYsc: shape({}).isRequired,
  location: shape({}).isRequired,
  fetchYscLimits: shape({}).isRequired,
  updateYscLimits: shape({}).isRequired,
  UserDetails: shape({}).isRequired,
  history: shape({}).isRequired,
  SelectUserDetails: shape({}).isRequired,
  GenerateOtpYsc: shape({}).isRequired,
  match: shape({
    params: shape({
      id: string,
      type: string,
    }),
  }).isRequired,
  onFetchCardDataYsc: func.isRequired,
  onFetchYscTransactionLimit: func.isRequired,
  onUpdateYscTransactionLimits: func.isRequired,
  onSetFetchTransactionLimits: func.isRequired,
  OnGenerateOtp: func.isRequired,
  onSetYscLimitOtpSuccess: func.isRequired,
};

const YscTransactionLimitsMapDispatchToProps = (dispatch) => ({
  onFetchCardDataYsc: (payload) => dispatch(fetchCardDataYsc(payload)),
  onFetchYscTransactionLimit: (payload) => dispatch(fetchYscTransactionLimit(payload)),
  onUpdateYscTransactionLimits: (payload) => dispatch(updateYscTransactionLimits(payload)),
  onSetFetchTransactionLimits: () => dispatch({ type: FETCH_YSC_TRANSACTION_LIMIT, payload: { status: false } }),
  OnGenerateOtp: (payload, otherparams) => dispatch(generateOtp(payload, otherparams)),
  onSetYscLimitOtpSuccess: () => dispatch({ type: GENERATE_OTP, payload: { status: false } }),
});

const YscTransactionLimitsMapStateToProps = createStructuredSelector({
  CardDataYsc: select_card_data_ysc(),
  fetchYscLimits: fetchYscTransaction(),
  updateYscLimits: updateYscTransaction(),
  isTransactionLimitsLoading: isTransactionLimitsLoading(),
  UserDetails: selectUserDetails(),
  SelectUserDetails: selectHeaderContainerJS('userDetails'),
  GenerateOtpYsc: generateOtpIndusind(),
  isLoadingStatus: isLoading(),
});

export { YscTransactionLimitsPropTypes, YscTransactionLimitsMapDispatchToProps, YscTransactionLimitsMapStateToProps };



// WEBPACK FOOTER //
// client/containers/YscTransactionLimits/YscTransactionLimitsDatahandler.js